<template>
  <el-container class="home-page">
    <el-header>
      <Header></Header>
    </el-header>
    <el-main>
      <div class="wrapper-content">
          <div class="wrapper-description">
              <div class="wrapper-description-content">
                  <div class="wrapper-title">量化交易，顶尖量化交易平台</div>
                  <div class="wrapper-info">秉承道德和诚信原则，借助科学与专业的力量, 立志成为全球顶尖的交易平台</div>
                  <!--
                  <div class="wrapper-btn">
                      <el-button type="info" @click="dialogVisible = true, flag = true">立即注册</el-button>
                      <el-button type="info" @click="dialogVisible = true, flag = false">登录</el-button>
                  </div>
                  -->
              </div>
          </div>
      </div>
      <div class="strategy-content">
        <div class="strategy-title">
            <h3>策略精选</h3>
        </div>
        <div class="strategy-chart">
          <Echart></Echart>
          <Echart></Echart>
          <Echart></Echart>
        </div>
        <div class="strategy-chart">
          <Echart></Echart>
          <Echart></Echart>
          <Echart></Echart>
        </div>
      </div>
      <div class="operation">
        <div class="opration-title">
          <h3>如何操作?</h3>
        </div>
        <el-row :gutter="20" class="operation-content">
          <el-col :span="8">
            <div class="grid-content bg-purple step-info">
              <span><i class="el-icon-edit"></i></span>
              <div>
                <h5>第一步. <span>签署合约</span></h5>
                <p class="guide-step-content">
                      在正式使用 bibite 服务前双方需要签署正式合约, 以明确各方的权益, 风险及职责, 为双方合作奠定良好基础
                </p>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple step-info">
              <span><i class="el-icon-postcard"></i></span>
              <div>
                <h5>第二步. <span>开户注资</span></h5>
                <p class="guide-step-content">
                      用户在 bibite 支持的加密货币交易所注册账户并完成注资, 然后配置指定数量的加密货币和法币
                </p>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple step-info">
              <span><i class="el-icon-link"></i></span>
              <div>
                <h5>第三步. <span>API交易授权</span></h5>
                <p class="guide-step-content">
                  交易所帐户创建仅有交易权限的API KEY, 然后在bibite管理平台提交API KEY并完成预付费用, bibite便会开始量化套利
                </p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-main>

    <el-dialog :visible.sync="dialogVisible" width="30%">
      <div class="login-content">
        <span slot="title" class="dialog-title clearfloat">
            <div class="dialog-logo">
                <i class="logo">
                    <img class="logo-style" id="logo-img" :src="logoImageUrl" type="image/svg+xml"/>
                </i>
                <h4 class="website">
                    bibite<span style="color: #db5634">.COM</span>
                </h4>
            </div>
            <div class="dialog-btn">
                <span @click="flag = true" :class="{'myblue': flag == true}"><a>注册</a></span>
                <span @click="flag = false" :class="{'myblue': flag == false}"><a>登录</a></span>
            </div>
        </span>
        <div class="component">
            <Regist v-if="flag == true"></Regist>
            <Login v-else></Login>
        </div>
      </div>
    </el-dialog>
    <Footer></Footer>
</el-container>
</template>

<script>
/* eslint-disable */
// @ is an alias to /src
import Header from '@/components/header/Header.vue'
import Footer from '@/components/Footer/Footer.vue'
import Echart from '@/views/home/home-echart.vue'
import Login from '@/components/Login.vue'
import Regist from '@/components/Regist.vue'
import { mapState } from 'vuex'

export default {
  name: 'home',
  components: {
    Header,
    Echart,
    Footer,
    Login,
    Regist
  },
  inject: ['reload'],
  data: function () {
    return {
      centerDialogVisible: false,
      userName: '',
      password: '',
      flag: false,
      logoImageUrl: require('../assets/img/lianghualogo.svg'),
      dialogVisible: false,
    }
  },
  computed: {
    ...mapState([
      'token'
    ])
  },
  mounted() {
  },
  methods: {
    
  }
}
</script>

<style lang="scss">
.home-page{
  margin-top: 0 !important;
}
  .wrapper-content{
    background: url('../assets/img/background.svg') no-repeat;
    background-size: 100% 100%;
    background-color: #000;
    height: 460px;
    .wrapper-description{
      color: aliceblue;
      float: left;
      padding: 10px;
      margin-left: 30px;
      position: relative;
      top: 50%;
      transform: translateY(-70%);
      width: 30%;
      .wrapper-title{
        font-size: 30px;
        padding: 5px;
        font-weight: bolder;
        text-align: left;
      }
      .wrapper-info{
        padding: 5px;
        margin-left: 30px;
      }
      .wrapper-btn{
        padding: 5px;
        a{
          color: #fff;
        }
      }
    }
  }
  .strategy-content{
    padding: 10px;
    color: aliceblue;
    .strategy-title{
      padding: 10px;
    }
    .strategy-chart{
      width: 70%;
      display: flex;
      justify-content: space-between;
      margin: 10px auto;
    }
  }
  header{
    padding: 0;
  }
  .el-main{
    padding: 0;
    background-color: #1e1e1e;
  }
  .el-footer{
    background-color: #000;
    height: 100% !important;
  }
  .opration-title{
    color: aliceblue;
    padding-bottom: 20px;
  }
  .operation-content{
    width: 70%;
    margin: 10px auto !important;
    .step-info{
      background-color: #2d2d2f;
      padding: 10px;
      height: 150px;
      span{
        padding: 5px;
        i{
          font-size: 30px;
          color: #929294;
        }
      }
      div{
        margin-top: 10px;
        h5{
          padding: 5px;
          font-size: 16px;
          font-weight: 600;
          color: #cbcbcc;
        }
        p{
          color: #929294;
        }
      }
    }
  }

  .el-dialog{
    .el-dialog__body{
      padding: 0 !important;
    }
    .el-dialog__header{
      background-color: #213a53 !important;
      padding: 0 !important;
    }
    .dialog-logo{
      // background: url('../assets/img/header-profile-skin-2.png') no-repeat !important;
      // background-color: #213a53 !important;
      background-size: cover !important;
    }
    
  }
  .dialog-title{
    
    span{
      padding: 5px;
      font-size: 20px;
      font-weight: 600;
    }
    span:hover{
      cursor: pointer;
    }
  }
  .login-content{
    // width: 25%;
    height: 50%;
    background-color: #2d2d2f;
    border-radius: 5px;
    box-shadow: 0 0 20px #000;
    margin: 70px auto;
    .component{
        margin: 10px 0;
        border: 0;
    }
    .dialog-btn{
        margin: 10px 0 0 0;
        padding: 5px;
        span{
            padding: 10px 10px;
            color: #807c7c;
            font-weight: 600;
            border-bottom: 2px solid #807c7c;
        }
        span:hover{
            cursor: pointer;
        }
    }
    .dialog-logo{
        padding: 15px;
        background-color: #1e1e1e;
        #logo-img{
            width: 30%;
        }
        h4{
            color: #fff;
        }
        .website{
            font-size: 1.5rem;
        }
    }
}
.myblue{
    color: #eb602e !important;
    border-bottom: 2px solid #eb602e !important;
}
  
</style>

